import React from 'react';
import { t } from '../lib/i18n';
import sendJIEvent from '../lib/kwizzad-ji.jsx';
import ContinueButton from './continue-button';

class PlaystoreButton extends ContinueButton {
    render() {
        return (<div className="toPlaystore">
            <div className="headline">{t('toPlaystore')}</div>
            <a
              href={this.href()}
              ref={link => this.link = link} // eslint-disable-line no-return-assign
              onClick={() => { sendJIEvent('call2ActionClicked'); }}
            >
                <img
                  alt={t('toPlaystore')}
                  src={t('playstoreBadge')}
                  className="questionImage"
                />
            </a>
            <div className="legal">{t('toPlaystoreLegal')}</div>
        </div>);
    }
}

export default PlaystoreButton;



// WEBPACK FOOTER //
// ./src/campaign/playstore-button.jsx